import { getFetch, postFetch } from '@/plugins/http'

const baseHost = `${process.env.VUE_APP_HOST}/hike-boot`

export default {
  /* 
    头部信息
  */
  /* 角色权限 */
  findbycourseTeam: (params, config) =>
    getFetch(`${baseHost}/common/api/30-findbycourseid_team/bk_my_course`, params, config),
  /* 课程概况信息查询 */
  courseInfo: (params, config) =>
    getFetch(`${baseHost}/common/api/30-info_course/bk_my_course`, params, config),
  /* 转让负责人列表 */
  transferLeaderList: (params, config) =>
    getFetch(`${baseHost}/common/api/34-transfer_leader_list/bk_my_course`, params, config),
  /* 更新封面 */
  updCourseCover: data =>
    postFetch(`${baseHost}/common/api/20-upd_course_cover/bk_my_course`, data),
  /* 更新基本信息 */
  updCourseBaseInfo: data =>
    postFetch(`${baseHost}/common/api/20-upd_course_name/bk_my_course`, data),
  /* 设置团队角色 */
  updTeamRole: data => postFetch(`${baseHost}/common/api/20-team_role_upd/bk_my_course`, data),
  /* 转让负责人 */
  transferLeader: data => postFetch(`${baseHost}/common/api/20-transfer_leader/bk_my_course`, data),
  /* 菜单列表 */
  getTabList: (params, config) =>
    getFetch(`${baseHost}/common/api/33-column_list/general_website`, params, config),
  getTabInfo: (params, config) =>
    getFetch(`${baseHost}/common/api/33-column_info/general_website`, params, config),
  addCourseMenu(data) {
    return postFetch(`${baseHost}/common/api/10-column_add/bk_my_course`, data)
  },
  /* 
  课程教案
  */
  getFirstOutline: (params, config) =>
    getFetch(`${baseHost}/common/api/32-first_outline/bk_my_course`, params, config),
  /* 课程教案侧边大纲查询 */
  getTreeOutlineinNUm: (params, config) =>
    getFetch(`${baseHost}/common/api/33-tree_outline_V2/bk_my_course`, params, config),
  /* 教案列表 */
  getTeachingPlan: (params, config) =>
    getFetch(`${baseHost}/common/api/32-outline_plans/bk_my_course`, params, config),
  /* 指派的教师列表 */
  assignTeacherList: (params, config) =>
    getFetch(`${baseHost}/common/api/33-assign_teacher_list/bk_my_course`, params, config),
  /* 教师选择列表 */
  assignChooseList: (params, config) =>
    getFetch(`${baseHost}/common/api/34-assign_choose/bk_my_course`, params, config),
  /* 教师大纲选择树 */
  treeOutlineAssign: (params, config) =>
    getFetch(`${baseHost}/common/api/33-tree_outline_assign/bk_my_course`, params, config),
  /* 指派教师 */
  assignTeacher: data => postFetch(`${baseHost}/common/api/20-assign_teacher/bk_my_course`, data),
  /* 删除教师 */
  deleteAssignTeacher: data =>
    postFetch(`${baseHost}/common/api/91-del_assign_teacher/bk_my_course`, data),
  /* 同步教师 */
  syncOutlineTeacher: data =>
    postFetch(`${baseHost}/common/api/20-sync_outline_teacher/bk_my_course`, data),
  /**
   * 课程管理_教案管理_分配章节
   */
  addOutlineToTeaching: data =>
    postFetch(`${baseHost}/common/api/20-plan_upd_outline/bk_my_course`, data),
  /*
   大纲管理
   */
  /* 大纲列表章节 */
  getCourseChapterTree: (params, config) =>
    getFetch(`${baseHost}/common/api/33-tree_outline/bk_my_course`, params, config),
  /* 添加大纲章节 */
  addOutline: data => postFetch(`${baseHost}/common/api/10-add_outline/bk_my_course`, data),
  /* 删除大纲章节 */
  delOutline: data => postFetch(`${baseHost}/common/api/91-del_outline/bk_my_course`, data),
  /* 更新大纲章节 */
  updOutline: data => postFetch(`${baseHost}/common/api/20-upd_outline/bk_my_course`, data),
  /* 排序大纲章节 */
  sortOutline: data => postFetch(`${baseHost}/common/api/20-sort_outline/bk_my_course`, data),
  /* 上传大纲章节 */
  uploadOutline: (data, config) => postFetch(`${baseHost}/bk/outline/importOutline2`, data, config),
  /* 拖动大纲章节 */
  dragOutline: (data, config) =>
    postFetch(`${baseHost}/common/api/20-sort2_outline/bk_my_course`, data, config),
  // 选择栏目树
  getSelectColumnList(params, config) {
    return getFetch(`${baseHost}/common/api/33-getResourceColumnVoList/bk_my_course`, params, config)
  },
  // 当前课程下待选教案列表
  getWaitCaseByCourseId: (parme, config) =>
    getFetch(`${baseHost}/common/api/34-case_list/bk_my_course`, parme, config),
  // 大纲批量分配课程管理_教案
  batchTeachingToOutline(params, config) {
    return postFetch(`${baseHost}/common/api/20-batch_plan_upd_outline/bk_my_course`, params, config)
  },
  // 复制大纲章节
  copyOutline: data => postFetch(`${baseHost}/common/api/10-copyOutlineData/bk_my_course`, data),
  // 我的课程-课程大纲-新增
  addCourseOutline: data => postFetch(`${baseHost}/common/api/10-syllabi_add/bk_my_course`, data),
  // 我的课程-课程大纲-修改
  updateCourseOutline: data => postFetch(`${baseHost}/common/api/10-syllabi_upd/bk_my_course`, data),
  // 我的课程-课程大纲-列表
  getMyCourseOutlineList: data => getFetch(`${baseHost}/common/api/34-syllabi_list/bk_my_course`, data),
  // 我的课程-课程大纲-设置终版
  setCourseOutlineFinalVersion: data => postFetch(`${baseHost}/common/api/20-syllabi_final/bk_my_course`, data),
  // 我的课程-课程大纲-删除
  deleteCourseOutline: data => postFetch(`${baseHost}/common/api/90-syllabi_del/bk_my_course`, data),

  /* 
  课程概况
  */
  /* 课程概况信息查询 */
  surveyCourse: (params, config) =>
    getFetch(`${baseHost}/common/api/30-survey_course/bk_my_course`, params, config),
  /* 课程类型列表 */
  getBkClassifyList: (params, config) =>
    getFetch(`${baseHost}/common/api/33-list_classify/bk_my_course`, params, config),
  /* 教材列表 */
  getMaterialList: (params, config) =>
    getFetch(`${baseHost}/common/api/34-list_material/bk_my_course`, params, config),
  /* 删除教材 */
  delMaterial: data => postFetch(`${baseHost}/common/api/91-del_material/bk_my_course`, data),
  /* 添加教材 */
  addMaterial: data => postFetch(`${baseHost}/common/api/10-add_material/bk_my_course`, data),
  /* 删除课程教材 */
  delCourseMaterial: data =>
    postFetch(`${baseHost}/common/api/90-del_course_material/bk_my_course`, data),
  /* 添加课程教材 */
  addCourseMaterial: data =>
    postFetch(`${baseHost}/common/api/10-add_course_material/bk_my_course`, data),
  /* 更新课程概况信息 */
  updSurveyCourse: data => postFetch(`${baseHost}/common/api/20-upd_course/bk_my_course`, data),
  /* 更新课程背景信息 */
  updDescription: data => postFetch(`${baseHost}/common/api/20-upd_description/bk_my_course`, data),
  /* 
  团队成员
  */
  /* 添加教师 教师列表 */
  teacherList: (params, config) =>
    getFetch(`${baseHost}/common/api/34-list_teacher/bk_my_course`, params, config),
  /* 获取团队成员列表 */
  getTeamDetail: (params, config) =>
    getFetch(`${baseHost}/common/api/30-findbyid_team/bk_my_course`, params, config),
  /* 获取团队详情 */
  getTeamList: (params, config) =>
    getFetch(`${baseHost}/common/api/33-list_team/bk_my_course`, params, config),
  /* 新增教师 */
  addTeacher: data => postFetch(`${baseHost}/common/api/10-add_team/bk_my_course`, data),
  /* 更新教师 */
  updTeacher: data => postFetch(`${baseHost}/common/api/20-upd_team/bk_my_course`, data),
  /* 删除教师 */
  delTeacher: data => postFetch(`${baseHost}/common/api/91-del_teacher/bk_my_course`, data),
  /* 排序教师 */
  sortTeacher: data => postFetch(`${baseHost}/common/api/20-sort/bk_my_course`, data),
  /* 
  课程资源
  */
  getCourseResourceTree: (params, config) =>
    getFetch(`${baseHost}/courseFile/getCourseOutlinesFile`, params, config),
  /* 资源列表 */
  getCourseResource: (params, config) =>
    getFetch(`${baseHost}/courseFile/getCourseResourcePageList`, params, config),
  /* 批量操作 */
  batchResourceOperateFile: data => postFetch(`${baseHost}/courseFile/batchOperateFile`, data),
  /* 保存资源 */
  saveResourceFile: data =>
    postFetch(`${baseHost}/courseFile/saveFile`, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }),
  /* 
  课程详细信息
  */
  getCourseResourceInfo: (params, config) =>
    getFetch(`${baseHost}/courseFile/getFileInfo`, params, config),
  updViewNum: data => postFetch(`${baseHost}/common/api/20-upd_view_num/bk_my_course`, data)
}
